import { useMemo } from 'react';

import { useAvailableSites } from '@atlaskit/linking-common/use-available-sites';
import { type AvailableSitesProductType } from '@atlaskit/linking-common/types';

/**
 * Hook to get the available products for the current user.
 * Returns empty array when the available products are not yet loaded.
 */
export const useAvailableProducts = (
	cloudId?: string,
): { availableProducts: AvailableSitesProductType[]; isLoading: boolean } => {
	const { data, loading: isLoading } = useAvailableSites();

	return {
		availableProducts: useMemo(() => {
			if (!data.length) {
				return [];
			}

			if (cloudId) {
				return data.find((site) => site.cloudId === cloudId)?.products ?? [];
			}

			// Get all the products from all sites and deduplicate
			return Array.from(
				data.reduce((prev, curr) => {
					return new Set([...curr.products, ...Array.from(prev)]);
				}, new Set<AvailableSitesProductType>()),
			);
		}, [data, cloudId]),
		isLoading,
	};
};
